export default function addPriceRange(pricing) {
  if (!pricing?.price) return null;
  return {
    ...pricing,
    priceRange: getPriceRange(pricing.price),
    priceStrategy: 'BY_PRICE_RANGE',
  };
}

export function getPriceRange(price) {
  return Object.entries(priceRanges).reduce((acc, [key, min]) => {
    if (price >= min) return key;
    return acc;
  }, null);
}

const priceRanges = {
  '€': 0,
  '€€': 5,
  '€€€': 10,
  '€€€€': 20,
  '€€€€€': 50,
  '€€€€€€': 100,
};
